import styled from "styled-components";
import { motion } from "framer-motion";

export const Section = styled.section`
  align-items: flex-start;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex: 0 0 auto;
  flex-flow: column;
  gap: 0px;
  height: min-content;
  overflow: visible;
  position: relative;
  width: 100%;
  z-index: 2;
  // min-height: 100vh;
`;

export const RoadMapContainer = styled.div`
  border-top: 4px solid rgb(247, 96, 0);
  align-items: center;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 60px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: clamp(40px, 8vw, 80px) 0;
  position: relative;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
    gap: 30px;
    padding: clamp(30px, 6vw, 60px) 0;
  }
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
`;

export const RoadMapContent = styled.div`
  align-items: center;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 16px;
  height: min-content;
  justify-content: flex-start;
  max-width: 840px;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const RoadMapSubTitle = styled.p`
  flex-shrink: 0;
  transform: none;
  font-size: 20px;
  letter-spacing: -0.01em;
  line-height: 130%;
  color: rgb(247, 96, 0);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const RoadMapTitle = styled.div`
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  will-change: transform;
  flex: none;
  height: auto;
  position: relative;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
`;

export const GradientText = styled.h2`
  font-family: "Inter Display", sans-serif;
  font-size: 48px;
  letter-spacing: -0.03em;
  line-height: 120%;
  font-weight: 400;
  color: rgb(204, 204, 204);
  background: linear-gradient(
    24deg,
    rgb(255, 255, 247) 0%,
    rgba(255, 255, 247, 0.34) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Line = styled(motion.div)`
  align-items: center;
  background: linear-gradient(
    90deg,
    #d6d6d600,
    #d6d6d63d 37.38738738738739%,
    #d6d6d699 51.96896114864865%,
    #b2b2b23d 66.27252252252251%,
    #0000 99.99999999999972%
  );
  display: flex;
  flex: none;
  height: 1px;
  justify-content: center;
  overflow: hidden;
  padding: 0 60px;
  position: relative;
  width: 100%;
  will-change: opacity;
`;

export const BenefitsContainer = styled.div`
  align-items: center;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 0 clamp(20px, 5vw, 60px) clamp(30px, 5vw, 60px);
  position: relative;
  width: 100%;
  z-index: 2;
`;

export const BenefitsWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 32px;
  height: min-content;
  justify-content: center;
  max-width: 1280px;
  overflow: visible;
  padding: 60px 0 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    padding: 30px 0 0;
  }
`;

export const BenefitsThumbnail = styled.div`
  align-items: center;
  background-color: #000;
  border-radius: 30px;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: sticky;
  top: 80px;
  width: 100%;
  max-width: 600px;
  aspect-ratio: 1/1;
  will-change: var(--framer-will-change-override, transform);
  z-index: 1;
  flex: 1 0 0px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ThumbnailMainWrapper = styled.div`
  flex: 1 0 0px;
  height: 1px;
  position: relative;
  width: 100%;
  z-index: 2;
`;

export const ThumbnailContentBox = styled.div`
  height: 100%;
  width: 100%;
  opacity: 1;
  overflow: hidden;
  position: relative;
`;

export const ThumbnailFrameContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
`;

export const ThumbnailImageBox = styled.div`
  background-color: rgb(0, 0, 0);
  height: 100%;
  width: 100%;
  border-radius: 30px;
  opacity: 1;
  overflow: hidden;
  position: relative;
  will-change: var(--framer-will-change-override, transform);
`;

export const ThumbnailMaskWrapper = styled.div`
  mask: linear-gradient(rgb(0, 0, 0) 80%, rgba(0, 0, 0, 0) 100%);
  opacity: 1;
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;
  height: 100%;
  justify-content: center;
  left: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
`;

export const ThumbnailImageContainer = styled.div`
  position: absolute;
  border-radius: inherit;
  inset: 0px;
`;

export const ThumbnailImg = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  object-position: center center;
  object-fit: cover;
`;

export const BenefitsContent = styled.div`
  align-items: center;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 60px;
  height: min-content;
  justify-content: flex-start;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 1px;

  @media (max-width: 768px) {
    gap: 30px;
  }
`;

export const BenefitsItem = styled(motion.div)`
  flex: none;
  height: 80vh;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    height: auto;
  }
`;

export const BenefitsItemLink = styled.a`
  border: 1px solid rgb(31, 31, 31);
  background: linear-gradient(rgb(30, 30, 30) 0%, rgb(20, 20, 20) 100%);
  height: 100%;
  width: 100%;
  border-radius: 30px;
  opacity: 1;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;
  justify-content: center;
  overflow: hidden;
  padding: clamp(25px, 4vw, 40px) clamp(30px, 6vw, 80px);
  position: relative;
  text-decoration: none;
  width: 100%;
  max-width: 600px;
  will-change: var(--framer-will-change-override, transform);

  @media (max-width: 1024px) {
    padding: clamp(20px, 3vw, 30px) clamp(25px, 5vw, 60px);
  }

  @media (max-width: 768px) {
    padding: clamp(15px, 2vw, 25px) clamp(20px, 4vw, 40px);
    max-width: 100%;
    height: auto;
    gap: 10px;
  }
`;

export const BenefitsItemGradient = styled.div`
  background: linear-gradient(rgb(26, 26, 26) 0%, rgba(0, 0, 0, 0) 100%);
  opacity: 1;
  flex: none;
  height: 84px;
  left: 0;
  overflow: visible;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  @media (max-width: 768px) {
    height: 15px;
  }
`;

export const BenefitsItemTitle = styled.p`
  font-family: "Impact", sans-serif;
  font-size: 24px;
  font-weight: 400;
  flex: none;
  white-space: pre;
  flex-shrink: 0;
  color: rgb(247, 96, 0);
  text-shadow: rgba(155, 221, 237, 0) 0px 0px 8px;
  transform: none;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const BenefitsItemSubtitle = styled.h3`
  flex: none;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  flex-shrink: 0;
  will-change: transform;
  opacity: 1;
  transform: perspective(1200px);
  font-family: "Inter Display", sans-serif;
  font-size: 48px;
  font-weight: 400;
  letter-spacing: -0.02em;
  line-height: 120%;
  color: rgb(204, 204, 204);

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const BenefitsItemDescription = styled.p`
  flex: none;
  max-width: 600px;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  flex-shrink: 0;
  will-change: transform;
  opacity: 1;
  transform: perspective(1200px);
  font-family: "Inter", "Inter Placeholder", sans-serif;
  font-size: 26px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 1.4em;
  text-align: left;
  color: rgb(232, 228, 216);

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
